import { createContext, useMemo, useState } from 'react';

export const ModulAvisContext = createContext({
    isModulAvisActive: false,
    setModulAvisActive: () => {}
});

const ModulAvisProvider = (props) => {
    const { children } = props;
    const [isModulAvisActive, setModulAvisActive] = useState(false);

    const contextValue = useMemo(
        () => ({
            isModulAvisActive,
            setModulAvisActive
        }),
        [isModulAvisActive]
    );

    return <ModulAvisContext.Provider value={contextValue}>{children}</ModulAvisContext.Provider>;
};

export default ModulAvisProvider;
